import axios from "axios"
import secureLocalStorage from "react-secure-storage"

const Configs = {
  // appurl: "/milano-jewellery/",
  appurl: "/",
  imageUrl: process.env.REACT_APP_IMAGE_PATH,
}

export const axiosbaseurl = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
})
axiosbaseurl.interceptors.request.use(
  config => {
    const token = secureLocalStorage.getItem("auth_token")
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

export default Configs
